import { render } from "./TableWidget.vue?vue&type=template&id=8f84de9e"
import script from "./TableWidget.vue?vue&type=script&lang=js"
export * from "./TableWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__